import { request } from '../lib/http'

export function fetchClientsFrotixPneus () {
  return request({
    url: `tires-clients`,
    method: 'get',
  })
}

export function setStatusFrotixPneus (data) {
  return request({
    url: `set-status-frotix-pneus`,
    method: 'post',
    data
  })
}
